module.exports = __webpack_public_path__ + "img/logorosepetal.2dc597da.png";